export default __webpack_public_path__ + "static/media/table4seatUnilateral.7125e839.svg";